import { Option } from '@cmg/common';

import { InvestorFirmContactFilterInput } from '../../../../../../../graphql';
import { InvestorContactSearch_InvestorContactPartsFragment } from './graphql/__generated__';

export type InvestorContactOption = Option<string | null>;

export const getInvestorContactSearchTextFilter = (
  searchText: string
): InvestorFirmContactFilterInput | undefined => {
  const trimmedText = searchText.trim();

  return trimmedText
    ? {
        or: [
          { name: { contains: trimmedText } },
          { email1: { contains: trimmedText } },
          { email2: { contains: trimmedText } },
        ],
      }
    : undefined;
};

export const getContactsOptions = (
  contacts: readonly InvestorContactSearch_InvestorContactPartsFragment[]
) => {
  return contacts.map<InvestorContactOption>(contact => {
    const email = contact.email1 ?? contact.email2 ?? '';

    return {
      value: contact.investorEmployeeId,
      label: contact.name,
      email,
    };
  });
};
